/**
 * @generated SignedSource<<a6a14638bc8d6350a4761266ab9ae339>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteCardRefetchQuery$variables = {
  id: string;
};
export type NoteCardRefetchQuery$data = {
  readonly note: {
    readonly " $fragmentSpreads": FragmentRefs<"NoteCard_note">;
  } | null;
};
export type NoteCardRefetchQuery = {
  response: NoteCardRefetchQuery$data;
  variables: NoteCardRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schemaVersion",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileId",
    "storageKey": null
  },
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileType",
    "storageKey": null
  },
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasOriginalBlock",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalBlockId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invitable",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "UserInternalAttributes",
  "kind": "LinkedField",
  "name": "internalAttributes",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noteId",
  "storageKey": null
},
v26 = [
  (v3/*: any*/),
  (v20/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalTaskId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v33 = [
  (v3/*: any*/)
],
v34 = {
  "kind": "InlineFragment",
  "selections": (v33/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "ActionItemIntegrationLinkNode",
  "kind": "LinkedField",
  "name": "actionItemIntegrationLink",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "actionItem",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        (v3/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    },
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "syncStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastSyncedError",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationProvider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "integrationData",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v30/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "listName",
              "storageKey": null
            },
            (v27/*: any*/),
            (v31/*: any*/)
          ],
          "type": "ClickupActionItemIntegrationSpecificDataNode",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalCardId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boardName",
              "storageKey": null
            }
          ],
          "type": "TrelloActionItemIntegrationSpecificDataNode",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v30/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalGroupName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalBoardId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalBoardName",
              "storageKey": null
            },
            (v27/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MondayUserNode",
              "kind": "LinkedField",
              "name": "mondayUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountSlug",
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "MondayActionItemIntegrationSpecificDataNode",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalIdentifier",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "teamName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "statusName",
              "storageKey": null
            },
            (v31/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "LinearUserNode",
              "kind": "LinkedField",
              "name": "linearUser",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v32/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "organizationUrlKey",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "LinearActionItemIntegrationSpecificDataNode",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v30/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalListId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalListName",
              "storageKey": null
            },
            (v27/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MicrosoftTodoUserNode",
              "kind": "LinkedField",
              "name": "microsoftTodoUser",
              "plural": false,
              "selections": [
                (v32/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "MicrosoftTodoActionItemIntegrationSpecificDataNode",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v30/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hubspotUrl",
              "storageKey": null
            }
          ],
          "type": "HubspotTaskActionItemIntegrationSpecificDataNode",
          "abstractKey": null
        },
        (v34/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": "blockId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v37 = {
  "alias": "blockKey",
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "AsanaBlockLinkNode",
  "kind": "LinkedField",
  "name": "asanablocklink",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AsanaProjectNode",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v38/*: any*/),
        (v39/*: any*/)
      ],
      "storageKey": null
    },
    (v39/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaType",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "context",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "TranscriptBulletPoint",
  "kind": "LinkedField",
  "name": "bulletPoints",
  "plural": true,
  "selections": [
    (v24/*: any*/),
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textShort",
      "storageKey": null
    },
    (v44/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "TranscriptActionItem",
  "kind": "LinkedField",
  "name": "actionItems",
  "plural": true,
  "selections": [
    (v43/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TranscriptActionItemAssignee",
      "kind": "LinkedField",
      "name": "assignees",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        (v20/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "insertedBlockKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "edited",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "TranscriptDecision",
  "kind": "LinkedField",
  "name": "decisions",
  "plural": true,
  "selections": [
    (v43/*: any*/),
    (v24/*: any*/),
    (v44/*: any*/)
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCallEnd",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoDuration",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoPosterUrl",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoUrl",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitlesVttUrl",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailVttUrl",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavourite",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanEdit",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transcriptTxtDownloadUrl",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewCount",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userVideoProgress",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "didViewerAttend",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiArtifactsTxtDownloadUrl",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "TranscriptChapter",
  "kind": "LinkedField",
  "name": "chapters",
  "plural": true,
  "selections": [
    (v43/*: any*/),
    (v10/*: any*/),
    (v45/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingKeyEvent",
  "kind": "LinkedField",
  "name": "meetingKeyEvents",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "participantName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeFromRecordingStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTimeFromRecordingStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTimestamp",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingRecordingCommentsData",
  "kind": "LinkedField",
  "name": "comments",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "threadId",
      "storageKey": null
    },
    (v63/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTimestamp",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v33/*: any*/),
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "RecordingParticipant",
  "kind": "LinkedField",
  "name": "allRelevantParticipants",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v66/*: any*/),
    (v67/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecording",
          "kind": "LinkedField",
          "name": "baseRecording",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecordingParticipant",
              "kind": "LinkedField",
              "name": "allRelevantParticipants",
              "plural": true,
              "selections": [
                (v20/*: any*/),
                (v18/*: any*/),
                (v21/*: any*/),
                (v66/*: any*/),
                (v67/*: any*/)
              ],
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MeetingRecordingClip",
      "abstractKey": null
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceRule",
  "storageKey": null
},
v74 = [
  (v3/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isViewer",
    "storageKey": null
  }
],
v75 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v29/*: any*/),
  (v71/*: any*/),
  (v28/*: any*/),
  (v66/*: any*/),
  (v16/*: any*/),
  (v23/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteCardRefetchQuery",
    "selections": [
      {
        "alias": "note",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NoteCard_note"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteCardRefetchQuery",
    "selections": [
      {
        "alias": "note",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawDraftJson",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventGuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finished",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finishedAt",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canUnlockNote",
                "storageKey": null
              },
              {
                "alias": "noteTitle",
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "noteType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "collapsedBlockKeys",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showAiAgendaBuilderFeatureToViewer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingAttachment",
                "kind": "LinkedField",
                "name": "eventAttachments",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              },
              {
                "alias": "linkedActionItems",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "linkedOnly",
                    "value": true
                  }
                ],
                "concreteType": "NoteBlock",
                "kind": "LinkedField",
                "name": "actionItems",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteBlock",
                    "kind": "LinkedField",
                    "name": "originalBlock",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "note",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stream",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v3/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isTodoStream",
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/)
                                ],
                                "type": "NoteStream",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "entityMap",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NoteUser",
                            "kind": "LinkedField",
                            "name": "noteuserSet",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v16/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              (v8/*: any*/)
                            ],
                            "type": "Note",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v17/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "done",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "wontDo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aiGenerated",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recordingId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recordingOffset",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dueDate",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userOrder",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userOrderWithinGroup",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "entityRanges",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "assigneeChangedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creatorId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "assigneeId",
                        "storageKey": null
                      },
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasAccessToNote",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCondition",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "completedBy",
                        "plural": false,
                        "selections": (v26/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteBlock",
                        "kind": "LinkedField",
                        "name": "originalBlock",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteBlockAssignment",
                        "kind": "LinkedField",
                        "name": "assignments",
                        "plural": true,
                        "selections": [
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "assignee",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v28/*: any*/),
                              (v16/*: any*/),
                              (v18/*: any*/),
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v28/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": "actionItems(linkedOnly:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasMeetingRecordings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "meetingRecordings",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCurrentlyRecording",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transcript",
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalRecordingProvider",
                    "storageKey": null
                  },
                  (v41/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "userWhoStartedRecording",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingSummary",
                    "kind": "LinkedField",
                    "name": "activeSummary",
                    "plural": false,
                    "selections": [
                      (v42/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TranscriptChapter",
                        "kind": "LinkedField",
                        "name": "chapters",
                        "plural": true,
                        "selections": [
                          (v45/*: any*/),
                          (v43/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activeRecapTemplate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templatedRecaps",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingPromptFeedback",
                        "kind": "LinkedField",
                        "name": "feedback",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "missingInformation",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notFactuallyCorrect",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dontLikeTheTone",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "other",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "otherFeedback",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "summaryWillBeDeleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recordingDataAutoDeletionDate",
                    "storageKey": null
                  },
                  (v49/*: any*/),
                  (v50/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasAskCopilotConversation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "artifactsReady",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingVideoAndTranscriptionDownloadUrl",
                    "storageKey": null
                  },
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanDelete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExternalAttendees",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingClip",
                    "kind": "LinkedField",
                    "name": "clips",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clipStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clipEnd",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v49/*: any*/),
                      (v42/*: any*/),
                      (v55/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v54/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": (v26/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": (v26/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v56/*: any*/),
                          (v57/*: any*/),
                          (v41/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v58/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MeetingRecordingClip",
                                "kind": "LinkedField",
                                "name": "clips",
                                "plural": true,
                                "selections": (v33/*: any*/),
                                "storageKey": null
                              },
                              (v59/*: any*/),
                              (v48/*: any*/),
                              (v60/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MeetingRecordingSummary",
                                "kind": "LinkedField",
                                "name": "activeSummary",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v62/*: any*/),
                              (v64/*: any*/)
                            ],
                            "type": "MeetingRecording",
                            "abstractKey": null
                          }
                        ],
                        "type": "MeetingRecordingInterface",
                        "abstractKey": "__isMeetingRecordingInterface"
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGeneratingRecapTemplate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "redactionIsInProgress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "regenerationForLanguageIsInProgress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recordingAndTranscriptWillBeDeleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transcriptDeletionReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordingVideoDeletionReason",
                    "storageKey": null
                  },
                  (v58/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "ownerAccount",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v10/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v62/*: any*/),
                  (v64/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SmartTrackerResult",
                    "kind": "LinkedField",
                    "name": "smartTrackers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trackerName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SmartTrackerMatch",
                        "kind": "LinkedField",
                        "name": "matches",
                        "plural": true,
                        "selections": [
                          (v63/*: any*/),
                          (v65/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showLowLanguageConfidenceRegenerationBanner",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canRegenerateSummary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingStats",
                    "kind": "LinkedField",
                    "name": "meetingStats",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingStatsUser",
                        "kind": "LinkedField",
                        "name": "userStats",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v28/*: any*/),
                          (v66/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "absent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTalkTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "joinedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "leftAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "actualStartTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "actualEndTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingSummary",
                    "kind": "LinkedField",
                    "name": "summaries",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v42/*: any*/),
                      (v4/*: any*/),
                      (v46/*: any*/),
                      (v61/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v18/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "detectedLanguage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "languageConfidenceScore",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasTranscript",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v68/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeetingRecordingCommentsData",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                              (v65/*: any*/),
                              (v69/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "users",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v18/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v70/*: any*/)
                        ],
                        "type": "MeetingRecording",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeetingRecording",
                            "kind": "LinkedField",
                            "name": "baseRecording",
                            "plural": false,
                            "selections": [
                              (v68/*: any*/),
                              (v3/*: any*/),
                              (v70/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MeetingRecordingClip",
                        "abstractKey": null
                      }
                    ],
                    "type": "MeetingRecordingInterface",
                    "abstractKey": "__isMeetingRecordingInterface"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "asanaActionItems",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "asanaOnly",
                    "value": true
                  }
                ],
                "concreteType": "NoteBlock",
                "kind": "LinkedField",
                "name": "actionItems",
                "plural": true,
                "selections": [
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v40/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": "actionItems(asanaOnly:true)"
              },
              {
                "alias": "integrationLinkedActionItems",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "integrationConnectedOnly",
                    "value": true
                  }
                ],
                "concreteType": "NoteBlock",
                "kind": "LinkedField",
                "name": "actionItems",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v14/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": "actionItems(integrationConnectedOnly:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteTemplateNode",
                    "kind": "LinkedField",
                    "name": "template",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v55/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visibility",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "proseDoc",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tags",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "upgradedProseDoc",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v38/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "watching",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "typeTag",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateHasBeenChanged",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "carryTalkingPoints",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "carryActionItems",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMeetingFeedbackPromptEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExternalUsers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fromSignupForViewer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "openActionItemCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "agendaBuilderTone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "agendaBuilderContext",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "schedulingMeetingAssistantAutomationIsActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamUser",
                    "kind": "LinkedField",
                    "name": "notestreamusers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "otherUser",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v18/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "department",
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v71/*: any*/),
                      (v28/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "relationshipToViewer",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "activeRecurring1on1Event",
                        "plural": false,
                        "selections": [
                          (v72/*: any*/),
                          (v73/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInternalAttributes",
                        "kind": "LinkedField",
                        "name": "internalAttributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "suggestedTopics",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "manager",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recordingMediaType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recordingMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "meetingRecapAutoShareSource",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "sendTo_S",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sendTo",
                            "storageKey": null
                          }
                        ],
                        "type": "StreamMeetingRecapAutoShareSettings",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "sendTo_U",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sendTo",
                            "storageKey": null
                          }
                        ],
                        "type": "UserMeetingRecapAutoShareSettings",
                        "abstractKey": null
                      },
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "autoRecordSetting",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v74/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "NoteStreamStreamBasedAutoRecordSource",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": (v74/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AutoRecordRule",
                            "kind": "LinkedField",
                            "name": "rules",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ruleLevel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AutoRecordRuleUser",
                                "kind": "LinkedField",
                                "name": "autoRecordRuleUsers",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": (v74/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cannotBeRecordedReason",
                            "storageKey": null
                          }
                        ],
                        "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasAnyAutomationActive",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastSeenAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v75/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "externalUsers",
                "plural": true,
                "selections": (v75/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v72/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "end",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "guid",
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Calendar",
                    "kind": "LinkedField",
                    "name": "calendar",
                    "plural": false,
                    "selections": (v33/*: any*/),
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConferenceCall",
                    "kind": "LinkedField",
                    "name": "conferenceCalls",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pin",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "location",
                    "storageKey": null
                  },
                  (v73/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userResponseStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isHidden",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrganizer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAllDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "attendees",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v18/*: any*/),
                      (v22/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v29/*: any*/),
                          (v71/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingAttachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasUsersWithExternalEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "willBeRecorded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConferenceCall",
                    "kind": "LinkedField",
                    "name": "mainConferenceCall",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOneOnOne",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeBlockType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attendeePersonCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalAttendeePersonCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "organizer",
                    "plural": false,
                    "selections": (v33/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Attachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filename",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "size",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filetype",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v21/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageDimensions",
                    "kind": "LinkedField",
                    "name": "dimensions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "directUrl",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "groupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "actionItemsCarriedForward",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "talkingPointsCarriedForward",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerDismissedCarryForwardActionItemBanner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerDismissedCarryForwardTalkingPointBanner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerAgendaGeneratorBannerDismissed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerSentMeetingFeedback",
                "storageKey": null
              },
              (v55/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingFeedbackResponseCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerShowAutomationTimeSaverBanner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "previousNote",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pendingTodoCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pendingAgendaCount",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reactions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteCommentsData",
                "kind": "LinkedField",
                "name": "comments",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blockKey",
                    "storageKey": null
                  },
                  (v69/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowAiFeatures",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowRecapEngagementStats",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecordingErrorIndicator",
                "kind": "LinkedField",
                "name": "recordingErrorIndicator",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "cancelledBy",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v20/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorType",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingBrief",
                "kind": "LinkedField",
                "name": "meetingBrief",
                "plural": false,
                "selections": (v33/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "previousNoteWithEvent",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecording",
                    "kind": "LinkedField",
                    "name": "meetingRecordings",
                    "plural": true,
                    "selections": (v33/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalAttendeeDomains",
                "storageKey": null
              },
              (v10/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingLink",
                "kind": "LinkedField",
                "name": "meetingRecordingLink",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteAccessRequestNode",
                "kind": "LinkedField",
                "name": "pendingAccessRequests",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "requestor",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v20/*: any*/),
                      (v18/*: any*/),
                      (v21/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9e20a539e59e131d81d3054e9c7f2d48",
    "id": null,
    "metadata": {},
    "name": "NoteCardRefetchQuery",
    "operationKind": "query",
    "text": "query NoteCardRefetchQuery(\n  $id: ID!\n) {\n  note: node(id: $id) {\n    __typename\n    ...NoteCard_note\n    id\n  }\n}\n\nfragment ActionItemData on NoteBlock {\n  id\n  key\n  type\n  text\n  done\n  wontDo\n  aiGenerated\n  recordingId\n  recordingOffset\n  hasOriginalBlock\n  updatedAt\n  dueDate\n  createdAt\n  userOrder\n  userOrderWithinGroup\n  entityRanges\n  assigneeChangedAt\n  creatorId\n  assigneeId\n  noteId\n  hasAccessToNote\n  hasLink\n  statusCondition\n  completedBy {\n    id\n    fullName\n  }\n  originalBlock {\n    id\n    noteId\n  }\n  note {\n    __typename\n    id\n    isLocked\n    entityMap\n    stream {\n      __typename\n      id\n      displayName\n      isTodoStream\n      isExternal\n      url\n      ... on NoteStream {\n        type\n      }\n    }\n    noteuserSet {\n      id\n      user {\n        id\n        email\n        firstName\n        fullName\n        image\n        isExternal\n        internalAttributes {\n          invitable\n          id\n        }\n      }\n    }\n    ... on Note {\n      type\n      url\n    }\n  }\n  assignments {\n    status\n    assignee {\n      id\n      fullName\n      image\n      isGuest\n      isExternal\n      email\n      isActive\n    }\n    id\n  }\n  creator {\n    id\n    fullName\n    image\n    isGuest\n    isExternal\n  }\n  actionItemIntegrationLink {\n    id\n    actionItem {\n      originalBlockId\n      id\n      key\n    }\n    createdAt\n    updatedAt\n    syncStatus\n    lastSyncedError\n    integrationProvider\n    integrationData {\n      __typename\n      ... on ClickupActionItemIntegrationSpecificDataNode {\n        __typename\n        externalTaskId\n        listName\n        status\n        statusColor\n      }\n      ... on TrelloActionItemIntegrationSpecificDataNode {\n        __typename\n        externalCardId\n        boardName\n      }\n      ... on MondayActionItemIntegrationSpecificDataNode {\n        __typename\n        externalTaskId\n        externalGroupName\n        externalBoardId\n        externalBoardName\n        status\n        mondayUser {\n          accountSlug\n          id\n        }\n      }\n      ... on LinearActionItemIntegrationSpecificDataNode {\n        __typename\n        externalIdentifier\n        teamName\n        statusName\n        statusColor\n        linearUser {\n          id\n          isConnected\n          organizationUrlKey\n        }\n      }\n      ... on MicrosoftTodoActionItemIntegrationSpecificDataNode {\n        __typename\n        externalTaskId\n        externalListId\n        externalListName\n        status\n        microsoftTodoUser {\n          isConnected\n          id\n        }\n      }\n      ... on HubspotTaskActionItemIntegrationSpecificDataNode {\n        __typename\n        externalTaskId\n        hubspotUrl\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  blockId: id\n  blockKey: key\n  asanablocklink {\n    id\n    project {\n      id\n      name\n      externalId\n    }\n    externalId\n  }\n}\n\nfragment ApplyTemplate_note on Note {\n  id\n  version\n  isLocked\n  stream {\n    isExternal\n    id\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment AskFellowHooks_useAskFellowButton_note on Note {\n  id\n}\n\nfragment AttachmentPreviewAttachment on Attachment {\n  id\n  filename\n  updatedAt\n  directUrl: url\n  size\n  dimensions {\n    width\n    height\n  }\n  filetype\n}\n\nfragment AttachmentsOrConference_event on Event {\n  start\n  end\n  guid\n  conferenceCalls {\n    provider\n    url\n  }\n  attachments {\n    provider\n    fileId\n    url\n    fileType\n    title\n  }\n}\n\nfragment AttachmentsRelay_note on Note {\n  id\n  attachments {\n    id\n    filename\n    updatedAt\n    url\n    size\n    filetype\n    creator {\n      id\n      image\n      fullName\n    }\n    dimensions {\n      width\n      height\n    }\n  }\n}\n\nfragment AutoRecordToggle_note on Note {\n  stream {\n    id\n    ...AutoRecordToggle_refetchableAutoRecordReason\n    ...AutoRecordToggle_refetchableAutoRecordIsOnForStream\n  }\n  event {\n    hasUsersWithExternalEmail\n    willBeRecorded\n    id\n  }\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n}\n\nfragment AutoRecordToggle_refetchableAutoRecordIsOnForStream on NoteStream {\n  schedulingMeetingAssistantAutomationIsActive\n  id\n}\n\nfragment AutoRecordToggle_refetchableAutoRecordReason on NoteStream {\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_stream\n  id\n}\n\nfragment AutoSendToEveryone_autoShareIsSetToEveryone_note on Note {\n  stream {\n    meetingRecapAutoShareSource {\n      __typename\n      ... on StreamMeetingRecapAutoShareSettings {\n        sendTo_S: sendTo\n      }\n      ... on UserMeetingRecapAutoShareSettings {\n        sendTo_U: sendTo\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment AutoSendToEveryone_note on Note {\n  stream {\n    id\n  }\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n}\n\nfragment CarryForward_MoreActionsMenu_note on Note {\n  id\n  previousNote {\n    pendingAgendaCount\n    pendingTodoCount\n    id\n  }\n}\n\nfragment CarryForward_note on Note {\n  id\n  actionItemsCarriedForward\n  talkingPointsCarriedForward\n  stream {\n    carryActionItems\n    carryTalkingPoints\n    id\n  }\n  previousNote {\n    pendingAgendaCount\n    pendingTodoCount\n    id\n  }\n}\n\nfragment ChaptersPanel_meetingRecording on MeetingRecording {\n  id\n  activeSummary {\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n    }\n    id\n  }\n  userVideoProgress\n}\n\nfragment ClipCutModal_meetingRecording on MeetingRecording {\n  __typename\n  id\n  transcript\n  meetingRecordedVideoDuration\n  meetingRecordedVideoUrl\n  subtitlesVttUrl\n  thumbnailVttUrl\n  ownerAccount {\n    __typename\n    id\n  }\n  note {\n    __typename\n    title\n    id\n  }\n  ...TranscriptPanel_Transcript_meetingRecording_1DbIRQ\n  ...TranscriptVideo_meetingRecording_1DbIRQ\n}\n\nfragment ClipsPanel_ClipCard_clip on MeetingRecordingClip {\n  id\n  title\n  viewerCanEdit\n  meetingRecordedVideoDuration\n  meetingRecordedVideoPosterUrl\n  meetingRecordedVideoUrl\n  summary\n  isFavourite\n  creator {\n    id\n    fullName\n  }\n  lastEditedBy {\n    id\n    fullName\n  }\n  ...utils_useGetURL_recording\n  ...ClipsPanel_RenameClipModal_clip\n  ...ClipsPanel_DeleteClipModal_clip\n}\n\nfragment ClipsPanel_ClipSummary_clip on MeetingRecordingClip {\n  id\n  title\n  meetingRecordedVideoDuration\n  summary\n}\n\nfragment ClipsPanel_DeleteClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_RenameClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_meetingRecording on MeetingRecording {\n  id\n  clips {\n    id\n    ...ClipsPanel_ClipCard_clip\n  }\n}\n\nfragment DeleteMeeting_note on Note {\n  id\n  viewerCanEdit\n  isLocked\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n  ...DeleteNoteModal_note\n}\n\nfragment DeleteNoteModal_note on Note {\n  id\n  title\n  eventStart\n  eventEnd\n  createdAt\n  meetingRecordings {\n    id\n    hasTranscript\n    meetingRecordedVideoUrl\n    clips {\n      id\n      title\n    }\n  }\n  stream {\n    id\n  }\n}\n\nfragment DislikeModal_meetingRecording on MeetingRecording {\n  id\n  canRegenerateSummary\n  activeSummary {\n    id\n    feedback {\n      id\n      missingInformation\n      notFactuallyCorrect\n      dontLikeTheTone\n      other\n      otherFeedback\n    }\n  }\n}\n\nfragment EditTemplateMenuItem_note on Note {\n  id\n  version\n  isLocked\n  stream {\n    id\n    template {\n      id\n      viewerCanEdit\n      visibility\n      title\n      summary\n      proseDoc\n      schemaVersion\n      tags\n    }\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment EndMeeting_note on Note {\n  id\n  event {\n    isOrganizer\n    id\n  }\n  stream {\n    isMeetingFeedbackPromptEnabled\n    id\n  }\n}\n\nfragment FilterByCompany_note on Note {\n  externalAttendeeDomains\n}\n\nfragment FloatingRecordingControls_note on Note {\n  id\n  ...PreMeetingControls_note\n  ...AskFellowHooks_useAskFellowButton_note\n}\n\nfragment HighlightsPanel_DecisionsHighlight_decisions on TranscriptDecision {\n  timestamp\n  text\n  context\n}\n\nfragment HighlightsPanel_meetingRecording_1DbIRQ on MeetingRecording {\n  __typename\n  id\n  hasExternalAttendees\n  activeSummary {\n    summary\n    createdAt\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n      insertedBlockKey\n      edited\n    }\n    decisions {\n      ...HighlightsPanel_DecisionsHighlight_decisions\n    }\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        timestamp\n        text\n        textShort\n        context\n      }\n    }\n    templatedRecaps\n    activeRecapTemplate\n    id\n  }\n  title\n  meetingCallEnd\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  recordingDataAutoDeletionDate\n  meetingRecordedVideoDuration\n  ...utils_AddedOrAvailableUntil_meetingRecording\n  userVideoProgress\n  smartTrackers {\n    trackerName\n    matches {\n      startTimestamp\n      endTimestamp\n    }\n  }\n  ownerAccount {\n    __typename\n    id\n  }\n  showLowLanguageConfidenceRegenerationBanner\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ\n  ...TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ\n}\n\nfragment HighlightsPanel_note on Note {\n  id\n  title\n  isLocked\n  viewerCanEdit\n}\n\nfragment JoinConferenceButton_event on Event {\n  guid\n  conferenceCalls {\n    provider\n    url\n  }\n}\n\nfragment LockNote_note on Note {\n  id\n  isLocked\n  canUnlockNote\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment MeetingBriefsSuggestedAction_note on Note {\n  id\n  meetingBrief {\n    id\n  }\n}\n\nfragment MeetingBriefs_useShowMeetingBriefSuggestedAction on Note {\n  event {\n    timeBlockType\n    attendeePersonCount\n    externalAttendeePersonCount\n    id\n  }\n  eventStart\n  eventEnd\n  groupName\n  previousNoteWithEvent {\n    meetingRecordings {\n      id\n    }\n    id\n  }\n  meetingBrief {\n    id\n  }\n  id\n}\n\nfragment MeetingContainerTabs_note on Note {\n  hasMeetingRecordings\n  meetingRecordings {\n    isCurrentlyRecording\n    id\n  }\n  ...utils_useMeetingRecorderStatus_note\n}\n\nfragment MeetingPhaseContext_note on Note {\n  id\n  groupName\n  event {\n    id\n    title\n    status\n    start\n    end\n    isAllDay\n    conferenceCalls {\n      provider\n      url\n    }\n    hasUsersWithExternalEmail\n  }\n  finished\n  eventGuid\n  url\n  account {\n    __typename\n    allowAiFeatures\n    id\n  }\n  stream {\n    id\n    schedulingMeetingAssistantAutomationIsActive\n  }\n  meetingRecordings {\n    id\n    status\n    externalRecordingProvider\n    meetingCallStart\n    mediaType\n    userWhoStartedRecording {\n      id\n      firstName\n    }\n  }\n  recordingErrorIndicator {\n    message\n    cancelledBy {\n      id\n      fullName\n      email\n    }\n    errorType\n    updatedAt\n  }\n  hasMeetingRecordings\n  ...utils_useAutoRefetchMeetingRecording_note\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n}\n\nfragment MeetingRecordingBanner_RecordMeetingButton_note on Note {\n  id\n  groupName\n  finished\n  account {\n    __typename\n    allowAiFeatures\n    id\n  }\n  meetingRecordings {\n    id\n    status\n  }\n  event {\n    start\n    end\n    status\n    conferenceCalls {\n      provider\n      url\n    }\n    id\n  }\n  stream {\n    id\n    hasAnyAutomationActive\n    schedulingMeetingAssistantAutomationIsActive\n  }\n  ...utils_useAutoRefetchMeetingRecording_note\n}\n\nfragment MeetingSummaryBanner_IfMeetingSummaryBannerHidden_note on Note {\n  ...MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note\n}\n\nfragment MeetingSummaryBanner_note on Note {\n  id\n  groupName\n  meetingRecordings {\n    id\n    transcript\n    activeSummary {\n      summary\n      id\n    }\n    meetingCallEnd\n    summaryWillBeDeleted\n    recordingDataAutoDeletionDate\n    ...utils_useLongestMeetingRecording_meetingRecordings\n    ...MeetingSummaryBanner_recording\n  }\n  ...MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note\n}\n\nfragment MeetingSummaryBanner_recording on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n  meetingRecordedVideoPosterUrl\n  recordingDataAutoDeletionDate\n  summaryWillBeDeleted\n  activeSummary {\n    chapters {\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n      timestamp\n      title\n    }\n    summary\n    id\n  }\n  hasAskCopilotConversation\n}\n\nfragment MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note on Note {\n  id\n  ...utils_useNoteHasRecordings_note\n  ...utils_useAutoRefetchMeetingRecording_note\n}\n\nfragment MenuItemTooltip_useGetPropsForExternalWorkspaces_note on Note {\n  stream {\n    isExternal\n    account {\n      __typename\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment MoreActionsMenu_note on Note {\n  id\n  noteTitle: title\n  isLocked\n  type\n  viewerCanEdit\n  meetingRecordingLink {\n    url\n    id\n  }\n  stream {\n    id\n    isExternal\n    displayName\n    account {\n      __typename\n      name\n      id\n    }\n  }\n  previousNote {\n    pendingAgendaCount\n    pendingTodoCount\n    id\n  }\n  hasMeetingRecordings\n  meetingRecordings {\n    id\n    viewerCanDelete\n    ...RecapHistory_meetingRecording\n    ...RegenerateForLanguageModalFragment_meetingRecording\n  }\n  ...MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note\n  ...ApplyTemplate_note\n  ...EditTemplateMenuItem_note\n  ...SaveAsTemplate_note\n  ...DeleteNoteModal_note\n  ...RecapLanguage_note\n  ...CarryForward_MoreActionsMenu_note\n  ...VersionHistory_note\n  ...LockNote_note\n  ...DeleteMeeting_note\n}\n\nfragment NoteCard_note on Note {\n  id\n  createdAt\n  updatedAt\n  rawDraftJson\n  eventTitle\n  eventGuid\n  eventStart\n  eventEnd\n  finished\n  finishedAt\n  isLocked\n  canUnlockNote\n  noteTitle: title\n  schemaVersion\n  noteType\n  version\n  url\n  collapsedBlockKeys\n  showAiAgendaBuilderFeatureToViewer\n  eventAttachments {\n    provider\n    fileId\n    url\n    fileType\n    title\n  }\n  linkedActionItems: actionItems(linkedOnly: true) {\n    hasOriginalBlock\n    originalBlockId\n    originalBlock {\n      key\n      note {\n        __typename\n        id\n        stream {\n          __typename\n          url\n          id\n        }\n      }\n      ...ActionItemData\n      id\n    }\n    id\n  }\n  hasMeetingRecordings\n  meetingRecordings {\n    id\n    isCurrentlyRecording\n    transcript\n  }\n  asanaActionItems: actionItems(asanaOnly: true) {\n    blockId: id\n    blockKey: key\n    asanablocklink {\n      id\n      project {\n        id\n        name\n        externalId\n      }\n      externalId\n    }\n    id\n  }\n  integrationLinkedActionItems: actionItems(integrationConnectedOnly: true) {\n    id\n    key\n    actionItemIntegrationLink {\n      id\n      actionItem {\n        originalBlockId\n        id\n        key\n      }\n      createdAt\n      updatedAt\n      syncStatus\n      lastSyncedError\n      integrationProvider\n      integrationData {\n        __typename\n        ... on ClickupActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          listName\n          status\n          statusColor\n        }\n        ... on TrelloActionItemIntegrationSpecificDataNode {\n          __typename\n          externalCardId\n          boardName\n        }\n        ... on MondayActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          externalGroupName\n          externalBoardId\n          externalBoardName\n          status\n          mondayUser {\n            accountSlug\n            id\n          }\n        }\n        ... on LinearActionItemIntegrationSpecificDataNode {\n          __typename\n          externalIdentifier\n          teamName\n          statusName\n          statusColor\n          linearUser {\n            id\n            isConnected\n            organizationUrlKey\n          }\n        }\n        ... on MicrosoftTodoActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          externalListId\n          externalListName\n          status\n          microsoftTodoUser {\n            isConnected\n            id\n          }\n        }\n        ... on HubspotTaskActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          hubspotUrl\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ...EditTemplateMenuItem_note\n  stream {\n    id\n    watching\n    displayName\n    type\n    typeTag\n    templateHasBeenChanged\n    carryTalkingPoints\n    carryActionItems\n    isMeetingFeedbackPromptEnabled\n    isExternal\n    hasExternalUsers\n    fromSignupForViewer\n    openActionItemCount\n    agendaBuilderTone\n    agendaBuilderContext\n    schedulingMeetingAssistantAutomationIsActive\n    account {\n      __typename\n      id\n      name\n    }\n    template {\n      id\n      upgradedProseDoc\n    }\n    notestreamusers {\n      user {\n        email\n        id\n      }\n      id\n    }\n    otherUser {\n      id\n      email\n      fullName\n      image\n      title\n      department\n      isActive\n      isConfigured\n      isGuest\n      type\n      relationshipToViewer\n      activeRecurring1on1Event {\n        start\n        recurrenceRule\n        id\n      }\n      internalAttributes {\n        suggestedTopics\n        manager {\n          id\n          fullName\n        }\n        id\n      }\n    }\n  }\n  noteuserSet {\n    id\n    lastSeenAt\n    user {\n      __typename\n      id\n      type\n      email\n      firstName\n      fullName\n      image\n      isActive\n      isConfigured\n      isGuest\n      isTopUser\n      isExternal\n      internalAttributes {\n        invitable\n        id\n      }\n    }\n  }\n  externalUsers {\n    __typename\n    id\n    type\n    email\n    firstName\n    fullName\n    image\n    isActive\n    isConfigured\n    isGuest\n    isTopUser\n    isExternal\n    internalAttributes {\n      invitable\n      id\n    }\n  }\n  event {\n    id\n    start\n    end\n    title\n    guid\n    type\n    calendar {\n      id\n    }\n    status\n    conferenceCalls {\n      provider\n      url\n      phoneNumber\n      pin\n    }\n    location\n    recurrenceRule\n    userResponseStatus\n    isHidden\n    isOrganizer\n    isAllDay\n    attendees {\n      __typename\n      email\n      invitable\n      fullName\n      image\n      user {\n        id\n        isActive\n        isConfigured\n        isTopUser\n      }\n    }\n    ...AttachmentsOrConference_event\n    ...JoinConferenceButton_event\n  }\n  ...AttachmentsRelay_note\n  attachments {\n    id\n    dimensions {\n      height\n      width\n    }\n    ...AttachmentPreviewAttachment\n  }\n  groupName\n  actionItemsCarriedForward\n  talkingPointsCarriedForward\n  viewerDismissedCarryForwardActionItemBanner\n  viewerDismissedCarryForwardTalkingPointBanner\n  viewerAgendaGeneratorBannerDismissed\n  viewerSentMeetingFeedback\n  viewerCanEdit\n  meetingFeedbackResponseCount\n  viewerShowAutomationTimeSaverBanner\n  previousNote {\n    pendingTodoCount\n    pendingAgendaCount\n    id\n  }\n  reactions\n  comments {\n    blockKey\n    count\n    users {\n      id\n      fullName\n      image\n      isExternal\n    }\n  }\n  ...FloatingRecordingControls_note\n  ...AskFellowHooks_useAskFellowButton_note\n  ...MeetingRecordingBanner_RecordMeetingButton_note\n  ...MeetingPhaseContext_note\n  ...MeetingSummaryBanner_note\n  ...MeetingSummaryBanner_IfMeetingSummaryBannerHidden_note\n  ...MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note\n  ...SendNotesModal_IncludeAISummaryFormField_note\n  ...SuggestedActions_note\n  ...SendNotesModal_note\n  ...TranscriptModal_note_1DbIRQ\n  ...NoteHeader_note\n  ...MeetingContainerTabs_note\n}\n\nfragment NoteHeaderNoteDateOrTimer_note on Note {\n  id\n  createdAt\n  eventStart\n  eventEnd\n  noteType\n  viewerCanEdit\n  stream {\n    isExternal\n    id\n  }\n  event {\n    status\n    id\n  }\n  eventGuid\n  ...NoteTimeSelectorModal_note\n}\n\nfragment NoteHeaderTitleAndDate_note on Note {\n  id\n  noteTitle: title\n  viewerCanEdit\n  url\n  stream {\n    displayName\n    isExternal\n    id\n  }\n  noteType\n  createdAt\n  eventGuid\n  eventStart\n  eventEnd\n  ...NoteTimeSelectorModal_note\n  ...NoteHeaderNoteDateOrTimer_note\n}\n\nfragment NoteHeader_note on Note {\n  id\n  noteTitle: title\n  noteType\n  hasMeetingRecordings\n  viewerCanEdit\n  stream {\n    id\n    displayName\n  }\n  ...NoteHeaderTitleAndDate_note\n  ...RecordingControls_note\n  event {\n    guid\n    ...JoinConferenceButton_event\n    id\n  }\n  ...MoreActionsMenu_note\n  ...RequestAccessTooltip_note\n}\n\nfragment NoteTimeSelectorModal_note on Note {\n  id\n  createdAt\n  eventStart\n  eventEnd\n}\n\nfragment OptionsMenu_AutoRecordMenu_refetchableAutoRecordReason on NoteStream {\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_stream\n  id\n}\n\nfragment OptionsMenu_note on Note {\n  stream {\n    id\n    schedulingMeetingAssistantAutomationIsActive\n    ...OptionsMenu_AutoRecordMenu_refetchableAutoRecordReason\n  }\n  event {\n    mainConferenceCall {\n      provider\n    }\n    conferenceCalls {\n      provider\n    }\n    id\n  }\n}\n\nfragment PreMeetingControls_note on Note {\n  event {\n    conferenceCalls {\n      provider\n      url\n    }\n    id\n  }\n  stream {\n    id\n    recordingMediaType\n    recordingMode\n  }\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n  ...AutoRecordToggle_note\n  ...OptionsMenu_note\n}\n\nfragment RecapHistory_meetingRecording on MeetingRecording {\n  id\n  meetingRecordedVideoDuration\n  activeSummary {\n    id\n  }\n  summaries {\n    id\n    summary\n    createdAt\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n      insertedBlockKey\n      edited\n    }\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n    }\n    decisions {\n      ...HighlightsPanel_DecisionsHighlight_decisions\n    }\n    creator {\n      id\n      fullName\n      email\n      image\n    }\n  }\n}\n\nfragment RecapLanguage_note on Note {\n  id\n  viewerCanEdit\n  isLocked\n  stream {\n    isExternal\n    id\n  }\n  meetingRecordings {\n    id\n    viewerCanDelete\n    ...RecapHistory_meetingRecording\n    ...utils_useLongestMeetingRecording_meetingRecordings\n    ...RegenerateForLanguageModalFragment_meetingRecording\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment RecordingControls_note on Note {\n  ...StartAndAutoRecordingControls_note\n}\n\nfragment RegenerateForLanguageModalFragment_meetingRecording on MeetingRecording {\n  id\n  detectedLanguage\n  languageConfidenceScore\n  canRegenerateSummary\n  regenerationForLanguageIsInProgress\n}\n\nfragment RequestAccessTooltip_note on Note {\n  id\n  pendingAccessRequests {\n    id\n    createdAt\n    requestor {\n      id\n      fullName\n      email\n      image\n      isExternal\n    }\n  }\n}\n\nfragment SaveAsTemplate_note on Note {\n  id\n  title\n  stream {\n    id\n  }\n  rawDraftJson\n  schemaVersion\n}\n\nfragment SendNotesModal_IncludeAISummaryFormField_note on Note {\n  meetingRecordings {\n    ...utils_useLongestMeetingRecording_meetingRecordings\n    id\n  }\n}\n\nfragment SendNotesModal_Timing_note on Note {\n  eventStart\n  eventEnd\n  eventTitle\n  noteTitle: title\n}\n\nfragment SendNotesModal_note on Note {\n  id\n  eventStart\n  eventEnd\n  finished\n  noteTitle: title\n  noteType\n  version\n  meetingRecordings {\n    id\n  }\n  stream {\n    id\n    isExternal\n  }\n  ...SendNotesModal_IncludeAISummaryFormField_note\n  ...SendNotesModal_Timing_note\n}\n\nfragment StartAndAutoRecordingControls_note on Note {\n  id\n  stream {\n    id\n    schedulingMeetingAssistantAutomationIsActive\n    ...StartAndAutoRecordingControls_refetchableAutoRecordReason\n  }\n  event {\n    hasUsersWithExternalEmail\n    guid\n    conferenceCalls {\n      provider\n      url\n    }\n    id\n  }\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n}\n\nfragment StartAndAutoRecordingControls_refetchableAutoRecordReason on NoteStream {\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_stream\n  id\n}\n\nfragment StatsPanel_note on Note {\n  eventStart\n  eventEnd\n  account {\n    __typename\n    allowRecapEngagementStats\n    id\n  }\n}\n\nfragment StreamAutoRecordAutomationConfig_useAutoRecordReason_stream on NoteStream {\n  autoRecordSetting {\n    __typename\n    ... on NoteStreamStreamBasedAutoRecordSource {\n      value\n      creator {\n        id\n        firstName\n        fullName\n        isViewer\n      }\n    }\n    ... on NoteStreamUserSettingsBasedAutoRecordEnableSource {\n      users {\n        id\n        firstName\n        fullName\n        isViewer\n      }\n      rules {\n        ruleLevel\n        autoRecordRuleUsers {\n          user {\n            id\n            firstName\n            fullName\n            isViewer\n          }\n        }\n        id\n      }\n      cannotBeRecordedReason\n    }\n  }\n}\n\nfragment SuggestedActions_note on Note {\n  id\n  viewerSentMeetingFeedback\n  event {\n    isOneOnOne\n    conferenceCalls {\n      provider\n      url\n    }\n    hasUsersWithExternalEmail\n    id\n  }\n  account {\n    __typename\n    allowAiFeatures\n    id\n  }\n  meetingRecordings {\n    id\n    artifactsReady\n  }\n  ...EndMeeting_note\n  ...CarryForward_note\n  ...AutoSendToEveryone_note\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n  ...AskFellowHooks_useAskFellowButton_note\n  ...MeetingBriefsSuggestedAction_note\n  ...MeetingBriefs_useShowMeetingBriefSuggestedAction\n  ...FilterByCompany_note\n}\n\nfragment Timeline_meetingKeyEvents on MeetingRecording {\n  meetingKeyEvents {\n    eventType\n    participantName\n    timeFromRecordingStart\n    endTimeFromRecordingStart\n    duration\n  }\n  comments {\n    threadId\n    startTimestamp\n  }\n}\n\nfragment TranscriptModalContentStats on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n  meetingStats {\n    userStats {\n      email\n      fullName\n      image\n      isGuest\n      isTopUser\n      absent\n      totalTalkTime\n      percentage\n      joinedAt\n      leftAt\n    }\n    actualStartTime\n    actualEndTime\n  }\n  id\n}\n\nfragment TranscriptModalContent_note on Note {\n  id\n  __typename\n  viewerCanEdit\n  ...TranscriptPanel_note\n}\n\nfragment TranscriptModalGenerating_RedactingPreview_meetingRecording on MeetingRecording {\n  mediaType\n}\n\nfragment TranscriptModal_meetingRecording_1DbIRQ on MeetingRecording {\n  __typename\n  id\n  title\n  url\n  subtitlesVttUrl\n  meetingRecordedVideoDuration\n  meetingRecordedVideoUrl\n  transcript\n  activeSummary {\n    id\n    summary\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n    }\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n    }\n    decisions {\n      timestamp\n      text\n    }\n    activeRecapTemplate\n    templatedRecaps\n  }\n  clips {\n    id\n    clipStart\n    clipEnd\n    ...ClipsPanel_ClipSummary_clip\n  }\n  isGeneratingRecapTemplate\n  redactionIsInProgress\n  regenerationForLanguageIsInProgress\n  hasAskCopilotConversation\n  thumbnailVttUrl\n  meetingCallStart\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  meetingRecordingVideoDeletionReason\n  recordingDataAutoDeletionDate\n  userVideoProgress\n  ownerAccount {\n    __typename\n    id\n  }\n  note {\n    __typename\n    title\n    id\n  }\n  ...Timeline_meetingKeyEvents\n  ...HighlightsPanel_meetingRecording_1DbIRQ\n  ...ChaptersPanel_meetingRecording\n  ...TranscriptVideo_meetingRecording_1DbIRQ\n  ...ClipsPanel_meetingRecording\n  ...TranscriptPanel_Transcript_meetingRecording_1DbIRQ\n  ...ClipCutModal_meetingRecording\n  ...DislikeModal_meetingRecording\n  ...TranscriptModalContentStats\n  ...TranscriptModalGenerating_RedactingPreview_meetingRecording\n}\n\nfragment TranscriptModal_note_1DbIRQ on Note {\n  id\n  groupName\n  eventStart\n  createdAt\n  title\n  meetingRecordings {\n    __typename\n    id\n    title\n    meetingCallStart\n    meetingCallEnd\n    meetingVideoAndTranscriptionDownloadUrl\n    meetingRecordedVideoUrl\n    subtitlesVttUrl\n    thumbnailVttUrl\n    isFavourite\n    viewerCanDelete\n    hasExternalAttendees\n    activeSummary {\n      id\n    }\n    clips {\n      id\n      subtitlesVttUrl\n      thumbnailVttUrl\n      ...TranscriptVideo_meetingRecording_1DbIRQ\n    }\n    ...TranscriptModal_meetingRecording_1DbIRQ\n    ...TranscriptVideo_meetingRecording_1DbIRQ\n    ...utils_useLongestMeetingRecording_meetingRecordings\n    ...utils_AddedOrAvailableUntil_meetingRecording\n    ...utils_useGetURL_recording\n    ...RecapHistory_meetingRecording\n    ...Timeline_meetingKeyEvents\n    ownerAccount {\n      __typename\n      id\n    }\n    mediaType\n  }\n  ...utils_useAutoRefetchMeetingRecording_note\n  ...utils_useMeetingRecorderStatus_note\n  ...HighlightsPanel_note\n  ...StatsPanel_note\n  ...TranscriptModalContent_note\n}\n\nfragment TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    id\n    detectedLanguage\n    languageConfidenceScore\n    ...RegenerateForLanguageModalFragment_meetingRecording\n  }\n}\n\nfragment TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  transcript\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    allRelevantParticipants {\n      ...TranscriptPanel_SpeakerRelabelForm_attendees\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      allRelevantParticipants {\n        ...TranscriptPanel_SpeakerRelabelForm_attendees\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_SpeakerRelabelForm_attendees on RecordingParticipant {\n  email\n  fullName\n  image\n  isTopUser\n  user {\n    id\n  }\n}\n\nfragment TranscriptPanel_TranscriptSegment_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  id\n  ownerAccount {\n    __typename\n    id\n  }\n  ...utils_useGetURL_recording\n}\n\nfragment TranscriptPanel_TranscriptSegment_note on Note {\n  id\n}\n\nfragment TranscriptPanel_Transcript_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    activeSummary {\n      id\n    }\n    canRegenerateSummary\n    comments {\n      threadId\n      startTimestamp\n      endTimestamp\n      count\n      users {\n        id\n        email\n        fullName\n        image\n        isExternal\n      }\n    }\n    showLowLanguageConfidenceRegenerationBanner\n  }\n  ownerAccount {\n    __typename\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_meetingRecording\n  ...Timeline_meetingKeyEvents\n  ...TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1DbIRQ\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n  ...TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ\n}\n\nfragment TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  transcript\n  ownerAccount {\n    __typename\n    id\n  }\n}\n\nfragment TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    ... on MeetingRecordingInterface {\n      __isMeetingRecordingInterface: __typename\n      ... on MeetingRecording {\n        allRelevantParticipants {\n          fullName\n          email\n          image\n          isTopUser\n          user {\n            id\n          }\n        }\n      }\n      ... on MeetingRecordingClip {\n        baseRecording {\n          allRelevantParticipants {\n            fullName\n            email\n            image\n            isTopUser\n            user {\n              id\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      ... on MeetingRecordingInterface {\n        __isMeetingRecordingInterface: __typename\n        ... on MeetingRecording {\n          allRelevantParticipants {\n            fullName\n            email\n            image\n            isTopUser\n            user {\n              id\n            }\n          }\n        }\n        ... on MeetingRecordingClip {\n          baseRecording {\n            allRelevantParticipants {\n              fullName\n              email\n              image\n              isTopUser\n              user {\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_note on Note {\n  id\n  isLocked\n  viewerCanEdit\n  noteuserSet {\n    id\n    user {\n      id\n      email\n      fullName\n      isGuest\n      image\n    }\n  }\n  event {\n    organizer {\n      id\n    }\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_note\n}\n\nfragment TranscriptVideo_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  ... on MeetingRecording {\n    userVideoProgress\n    clips {\n      id\n    }\n    didViewerAttend\n  }\n  ...Video_meetingRecording\n}\n\nfragment VersionHistory_note on Note {\n  id\n  hasMeetingRecordings\n  meetingRecordings {\n    id\n    ...RecapHistory_meetingRecording\n  }\n}\n\nfragment Video_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  createdAt\n  isFavourite\n  meetingRecordedVideoUrl\n  transcriptTxtDownloadUrl\n  meetingRecordedVideoPosterUrl\n  viewCount\n  mediaType\n  ... on MeetingRecording {\n    meetingCallEnd\n    aiArtifactsTxtDownloadUrl\n    activeSummary {\n      chapters {\n        timestamp\n        title\n        bulletPoints {\n          text\n          timestamp\n          textShort\n          context\n        }\n      }\n      id\n    }\n    ...Timeline_meetingKeyEvents\n  }\n}\n\nfragment utils_AddedOrAvailableUntil_meetingRecording on MeetingRecording {\n  meetingCallEnd\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  meetingRecordingVideoDeletionReason\n  recordingDataAutoDeletionDate\n}\n\nfragment utils_useAutoRefetchMeetingRecording_note on Note {\n  id\n  finished\n  groupName\n  meetingRecordings {\n    id\n    meetingCallStart\n    status\n  }\n}\n\nfragment utils_useGetURL_recording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  ... on MeetingRecording {\n    id\n  }\n  ... on MeetingRecordingClip {\n    id\n  }\n}\n\nfragment utils_useLongestMeetingRecording_meetingRecordings on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n}\n\nfragment utils_useMeetingRecorderStatus_note on Note {\n  groupName\n}\n\nfragment utils_useNoteHasRecordings_note on Note {\n  meetingRecordings {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d769cb88cc53e67cf00e138d47beeae4";

export default node;
